import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";

import * as actions from "../../../../../redux/tasks/actions";
import type SubTask from "../../models/SubTask";
import type User from "../../models/User";

type Props = {
  user: ?User,
  subtask: ?SubTask,
  onModalClose: () => void,
  onDelete: () => void,
};

type StateProps = {
  activeProject: ?Project,
};

type State = {};

class SubTaskDeleteModal extends Component {
  props: Props;
  state: State = {};
  deleteSubTaskPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  deletePress = () => {
    this.handleDeletePress();
  };

  async handleDeletePress() {
    await this.deleteSubTask({
      ...this.props.subtask.toJS(),
    });
    this.props.onModalClose();
  }

  deleteSubTask(subTask: SubTask): Promise<void> {
    this.deleteSubTaskPromise = Promise.resolve(
      this.props.deleteSubTask(subTask)
    );
    return this.deleteSubTaskPromise;
  }

  render() {
    if (this.props.subtask) {
      return (
        <div>
          <Modal.Dialog>
            <Modal.Header>
              <Modal.Title>Delete Task</Modal.Title>
            </Modal.Header>
            <Modal.Body className="deuppercase-children">
              Are you sure you want to delete this task?
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={this.props.onModalClose}>Cancel</Button>
              <Button type="submit" onClick={this.deletePress} bsStyle="danger">
                Delete
              </Button>
            </Modal.Footer>
          </Modal.Dialog>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, actions)(SubTaskDeleteModal);



// WEBPACK FOOTER //
// ./src/views/user/components/modals/subtask-delete-modal/SubTaskDeleteModal.js